import { useEffect, useState } from "react";
import { Package, ShoppingBag, Users, AlertTriangle, MessageSquare, RefreshCw, DollarSign } from "lucide-react";
import api from "../../lib/api";

const Stat = ({ icon: Icon, label, value, accent }) => (
  <div className="card-luxe p-6">
    <div className="flex items-start justify-between">
      <div>
        <div className="overline mb-2">{label}</div>
        <div className={`font-display text-3xl ${accent? "text-copper" : "text-white"}`}>{value}</div>
      </div>
      <Icon size={20} className="text-white/30"/>
    </div>
  </div>
);

export default function DevOverview() {
  const [s, setS] = useState({});
  const [ai, setAi] = useState({});
  useEffect(() => {
    api.get("/admin/stats").then(r=>setS(r.data));
    api.get("/developer/ai-usage").then(r=>setAi(r.data));
  }, []);
  return (
    <div className="space-y-8">
      <div>
        <div className="overline mb-2">Developer Console</div>
        <h1 className="font-display text-4xl text-white">System Overview</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat icon={DollarSign} label="Revenue" value={`AED ${(s.revenue||0).toLocaleString()}`} accent/>
        <Stat icon={Package} label="Orders" value={s.total_orders||0}/>
        <Stat icon={ShoppingBag} label="Products" value={s.total_products||0}/>
        <Stat icon={Users} label="Customers" value={s.total_users||0}/>
        <Stat icon={AlertTriangle} label="Out of Stock" value={s.out_of_stock||0}/>
        <Stat icon={MessageSquare} label="Open Enquiries" value={s.pending_enquiries||0}/>
        <Stat icon={RefreshCw} label="Refund Requests" value={s.pending_refunds||0}/>
        <Stat icon={Package} label="AI Today" value={`${ai.global_today||0}/${ai.global_daily_limit||0}`} accent/>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="card-luxe p-6">
          <div className="overline mb-4">Recent Orders</div>
          {(s.recent_orders||[]).length === 0 ? <div className="text-white/40 text-sm">No orders yet</div> :
            <div className="space-y-3">{s.recent_orders.map(o => (
              <div key={o.id} className="flex justify-between text-sm py-2 border-b border-white/5 last:border-0">
                <div><div className="text-white">{o.order_number}</div><div className="text-white/40 text-xs">{o.customer_name}</div></div>
                <div className="text-right"><div className="text-copper">AED {o.total.toLocaleString()}</div><div className="text-white/40 text-xs uppercase tracking-luxe">{o.status}</div></div>
              </div>
            ))}</div>
          }
        </div>
        <div className="card-luxe p-6">
          <div className="overline mb-4">AI Cost (Estimated)</div>
          <div className="flex justify-between py-2 border-b border-white/5"><span className="text-white/60 text-sm">Today</span><span className="font-display text-xl text-copper">${(ai.cost_today||0).toFixed(2)}</span></div>
          <div className="flex justify-between py-2 border-b border-white/5"><span className="text-white/60 text-sm">Month</span><span className="font-display text-xl text-copper">${(ai.cost_month||0).toFixed(2)}</span></div>
          <div className="flex justify-between py-2"><span className="text-white/60 text-sm">Per image</span><span className="text-white text-sm">${(ai.cost_per_image||0).toFixed(2)}</span></div>
        </div>
      </div>
    </div>
  );
}
